<div class="text-center mb-4 pt-4 pb-4" *ngIf="!account?.countryCode">
  <p>Your profile seems to be missing some vital information. Kindly update your profile to continue.</p>
</div>

<ng-template #container></ng-template>
